import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox-indeterminate",
  "use": "checkbox-indeterminate-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"checkbox-indeterminate\">\n<title></title>\n<g id=\"checkbox-indeterminate_icomoon-ignore\">\n</g>\n<path d=\"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM793.6 576h-563.2v-128h563.2v128z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol